import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { removeOutcomes } from "./api";
import { invalidateAllQueries } from "utils/utils";

export function useRemoveOutcome({ ...options } = {}) {
    return useMutation({
        mutationFn: ({ id }) => removeOutcomes(id),
        onSuccess: () => {
            invalidateAllQueries();
            toast.success("Removed outcome Successfully");
            options.onSuccess?.();
        },
        onError: () => {
            toast.error("Error Removing outcome");
        },
    });
}
